import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={{
      backgroundColor: '#000503', borderTop: '1px solid #1a2744',
      padding: '40px', color: '#a0aec0'
    }}>
      <div style={{
        maxWidth: '1200px', margin: '0 auto',
        display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '32px'
      }}>
        {/* Company */}
        <div>
          <h3 style={{ color: '#fff', fontSize: '1rem', marginBottom: '16px' }}>Company</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Link to="/about" style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.9rem' }}>About Us</Link>
            <Link to="/partners" style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.9rem' }}>Partners</Link>
            <Link to="/news" style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.9rem' }}>News</Link>
            <Link to="/contact" style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.9rem' }}>Contact</Link>
          </div>
        </div>

        {/* Products */}
        <div>
          <h3 style={{ color: '#fff', fontSize: '1rem', marginBottom: '16px' }}>Products</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Link to="/naascloud" style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.9rem' }}>NaaS Cloud</Link>
            <Link to="/nac" style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.9rem' }}>Network Access Control</Link>
            <Link to="/security" style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.9rem' }}>Security</Link>
            <Link to="/openhardware" style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.9rem' }}>Open Hardware</Link>
          </div>
        </div>

        {/* Solutions */}
        <div>
          <h3 style={{ color: '#fff', fontSize: '1rem', marginBottom: '16px' }}>Solutions</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Link to="/mdu" style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.9rem' }}>MDU</Link>
            <Link to="/hospitality" style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.9rem' }}>Hospitality</Link>
            <Link to="/education" style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.9rem' }}>Education</Link>
            <Link to="/warehouses" style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.9rem' }}>Warehouses</Link>
          </div>
        </div>

        {/* Resources */}
        <div>
          <h3 style={{ color: '#fff', fontSize: '1rem', marginBottom: '16px' }}>Resources</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Link to="/whitepapers" style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.9rem' }}>White Papers</Link>
            <Link to="/knowledgecenter" style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.9rem' }}>Knowledge Center</Link>
            <Link to="/blogs" style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.9rem' }}>Blog</Link>
          </div>
        </div>

        {/* Contact */}
        <div>
          <h3 style={{ color: '#fff', fontSize: '1rem', marginBottom: '16px' }}>Contact</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <a href="mailto:info@sarvanta.ai" style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.9rem' }}>info@sarvanta.ai</a>
            <a href="https://www.sarvanta.ai" target="_blank" rel="noopener noreferrer" style={{ color: '#a0aec0', textDecoration: 'none', fontSize: '0.9rem' }}>www.sarvanta.ai</a>
          </div>
        </div>
      </div>

      <div style={{
        maxWidth: '1200px', margin: '32px auto 0', paddingTop: '24px',
        borderTop: '1px solid #1a2744', textAlign: 'center', fontSize: '0.85rem'
      }}>
        <p>&copy; {new Date().getFullYear()} Sarvanta. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
